<template>
    <v-navigation-drawer v-bind:value="value" v-on:input="$emit('input', $event)" clipped absolute temporary app disable-resize-watcher>
        <v-list class="pt-0">
            <v-list-tile @click="" to="/">
                <v-list-tile-action>
                    <v-icon>home</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>Home</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="" to="/booking">
                <v-list-tile-action>
                    <v-icon>email</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t("home.book")}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="" to="/rooms">
                <v-list-tile-action>
                    <v-icon>meeting_room</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t("home.rooms")}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="" to="/services">
                <v-list-tile-action>
                    <v-icon>fas fa-concierge-bell</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t("home.services")}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="" to="/contact">
                <v-list-tile-action>
                    <v-icon>mail</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t("home.contact")}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="" to="/promo">
                <v-list-tile-action>
                    <v-icon>fas fa-tag</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t("home.promo")}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            
        }
    }
}
</script>

<style scoped>

</style>